/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/merkliste.ts.
 */
import {User} from './user';
import {MerklistEntry} from './merklist-entry';

/**
 * Zweck: Beschreibt class Merkliste und ihren Daten- oder Funktionsvertrag.
 */
export class Merkliste {
  id: number;
  label: string;
  note: string;
  entries: MerklistEntry[];
  shared: boolean;
  readonly_impersonation_workspace: boolean;
  artikel_count: number;
  owner: boolean;
  owner_user: User;
}
